module.exports = __webpack_public_path__ + "static/homepage-social-image-5b22813d53ecb1122a35e486f4865c00.jpg";